import type { FC } from 'react';
import { useLocale } from 'next-intl';
import type { Price } from '@/ui/models/price';
import useTranslations from '@/core/hooks/use-translations';
import Typography from '@/ui/components/Typography/Typography';
import formatPrice from '@/ui/utils/formatPrice/formatPrice';

import $ from './Pricing.module.scss';

export type PricingProps = {
  price: Price;
  currency: string;
  isUsedInHeader?: boolean;
  withFrom?: boolean;
  withTaxNote?: boolean;
};

const Pricing: FC<PricingProps> = ({
  price,
  currency,
  isUsedInHeader = false,
  withFrom = true,
  withTaxNote = false,
}) => {
  const { originalPrice, salePrice } = price;
  const t = useTranslations();
  const locale = useLocale();

  return (
    <div className={$.container}>
      {withFrom && (
        <Typography variant="bodySmall">
          {t('web_pdp_productHeader_from')}
        </Typography>
      )}

      {typeof salePrice === 'number' && (
        <>
          <Typography
            variant="bodyLarge"
            className={isUsedInHeader ? $.originalPriceHeader : $.originalPrice}
          >
            {formatPrice(originalPrice, currency, locale)}
          </Typography>
          <Typography variant="bodyLarge" weight="medium">
            {formatPrice(salePrice, currency, locale)}
          </Typography>
        </>
      )}

      {typeof salePrice !== 'number' && (
        <Typography variant="bodyLarge" weight="medium">
          {formatPrice(originalPrice, currency, locale)}
        </Typography>
      )}
      {withTaxNote && (
        <Typography variant="bodySmall" className={$.taxNote}>
          {t('web_general_label_inclTaxes')}
        </Typography>
      )}
    </div>
  );
};

export default Pricing;
